module.exports = __webpack_public_path__ + "images/wxwork/img-phoneprev@3x-5aa8c91115d71a55428d37d4455e158c.png";